export const baseApiUrl = `${process.env.VUE_APP_BASE_API_URL}/api`;
export const baseApiUrl1 = `${process.env.VUE_APP_BASE_API_URL_1}`;
export const basePlanerApiUrl = `${process.env.VUE_APP_PLANER_API_URL}/`;
